import { Link } from 'react-router-dom';
import ctaBg from '../../../assets/images/cta-bg.jpg';

const CtaSection = () => (
  <section className="bg-[#0A0A0F] py-28 px-6 md:px-10">
    <div className="max-w-5xl mx-auto">
      <div className="relative rounded-3xl overflow-hidden">
        <img
          src={ctaBg}
          alt="Louvor ao vivo"
          className="w-full h-[420px] md:h-[500px] object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-[#0A0A0F]/60 to-transparent"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-16 px-8 text-center">
          <h2 className="text-4xl md:text-6xl font-light text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Seu ministério merece<br />
            <em className="not-italic text-[#C8A96E] font-bold">a melhor ferramenta.</em>
          </h2>
          <p className="text-white/50 text-base mb-10 max-w-lg">
            Comece gratuitamente hoje. Sem cartão de crédito. Sem compromisso.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/auth?mode=register"
              className="bg-[#C8A96E] text-[#0A0A0F] font-semibold px-10 py-4 rounded-full hover:bg-[#D4B87A] transition-colors whitespace-nowrap cursor-pointer"
            >
              Começar gratuitamente
            </Link>
            <Link
              to="/plans"
              className="border border-white/30 text-white px-10 py-4 rounded-full hover:border-white/60 hover:bg-white/5 transition-colors whitespace-nowrap cursor-pointer"
            >
              Ver planos
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CtaSection;
